
import { Component, Vue } from 'vue-property-decorator'
import Project from "@/types/project/project"
import { ProjectService } from "@/services/timetrack/ProjectService"
import CreateProject from "@/components/Project/CreateProject.vue"
import { TimesService } from "@/services/timetrack/TimesService"
import Tracking from "@/types/tracking/tracking"

@Component({
  filters: {
  },
  components: {
    CreateProject
  }
})
export default class ProjectTable extends Vue {
  private createDialog = false
  private projectsLoading = false
  private projects: Project[] = []
  private projectService = new ProjectService()
  private projectHeaders = [
    { text: this.$t('timetrack.projects.projectdata.name'), value: 'name', sortable: false },
    { text: this.$t('timetrack.projects.projectdata.description'), value: 'description', sortable: false, align: this.$vuetify.breakpoint.mdAndDown ? ' d-none' : 'start' },
    { text: this.$t('timetrack.projects.projectdata.actions'), value: 'actions', sortable: false, align: this.$vuetify.breakpoint.mdAndDown ? ' d-none' : 'end' }
  ]

  created () {
    this.fetchProjects()
    this.$parent.$on('projectCreated', this.fetchProjects)
  }

  private fetchProjects () {
    this.projectsLoading = true
    this.projectService.getAllProjects()
      .then((projects) => {
        if (projects) {
          this.projects = projects as Project[]
        }
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.projectsLoading = false
      })
  }

  private saveProject (projectData: Project) {
    if (!projectData) {
      return
    }
    this.projectService.createProject(projectData)
      .catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.fetchProjects()
        this.projectsLoading = false
        this.createDialog = false
      })
  }

  private handleProjectClicked (project: Project) {
    if (project && project.id) {
      this.$store.dispatch('project/setProject', new Project({ ...project }))
      this.$router.push({ path: '/timetrack/project/' + project.id })
    }
  }
}
